module.exports = {
  EnrichedPDF: {
    Allow_fullscreen: "Allow fullscreen",
    Show_controls: "Show Controls",
    URL: "URL",
    background_color: "Background color",
    border_color: "Border color",
    border_size: "Border Size",
    border_style: "Border Style",
    box_style: "Box style",
    Coords: "Coordinates",
    opacity: "Opacity",
    padding: "Padding",
    empty_title: "Add a PDF",
    empty_hint: "Upload a PDF from Files or paste a link into the URL field on the right panel.",
    loading: "Loading PDF…",
    unavailable_title: "PDF viewer unavailable",
    unavailable_hint: "The PDF library could not be loaded. Please refresh the page.",
    PluginName: "PDF Viewer",
    radius: "Radius",
    source: "Source",
    message_mark_xyp:
      "You've chosen an incorrect value. You must introduce three numbers separated by a comma. E.g. 4.56,90.76,1",
    message_mark_percentage:
      "You've chosen an incorrect value. You must introduce a percentage between 0 and 100. E.g.. 45.66%",
  },
};
